import { HubConnectionBuilder } from "@microsoft/signalr";

export default {
  configureOidcAuth({state}){
    state.oidcSettings.authority = state.config.CF_AUTH_URL,
    state.oidcSettings.redirectUri= state.config.BASE_URL+'/oidc-callback',
    state.oidcSettings.silentRedirectUri = state.config.BASE_URL+"/silent-renew-oidc"
  },
  connectToHub({dispatch,commit,getters}){
    let connection = new HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_CF_API_URL + "/notificationsHub", { accessTokenFactory: () => getters.oidcAccessToken })
      .configureLogging({logging: process.env.SIGNALR_LOG_LEVEL})
      .build();
    connection.onclose(()=>{ 
      console.log('Conexión con el hub cerrada.')
      setTimeout(dispatch('connectToHub'),1000)
    })
    connection.start().then(()=> {
      console.log('hub connection', connection)
      commit('setHubConnection', connection)
    })
    .catch(()=>setTimeout(dispatch('connectToHub'),1000))
    
    connection.on("SendNotification", data =>{
      
      let text ="";
      switch(data.type) {
        case 0:
          text=`Se acredito pago de dividendos para el proyecto ${data.additionalInfo}`
          break;
        case 1:
          text=`Se completo la orden para el proyecto ${data.additionalInfo}`
          break;
        case 2:
          text=`Se finalizo campaña de fondeo para el proyecto ${data.additionalInfo}`
          break;
        case 3:
          text=`Hay nueva campaña de fondeo para el proyecto ${data.additionalInfo}`
          break;
        case 4:
          text=`Se aprobo borrador de campaña de fondeo para el proyecto ${data.additionalInfo}`
          break;
        case 5:
          text=`Se publico campaña de fondeo para el proyecto ${data.additionalInfo}`
          break;
        case 6:
          text=`Se aprobo el proyecto ${data.additionalInfo}`
          break;
        case 7:
          text=`Se publico el proyecto ${data.additionalInfo}`
          break;
        default:
          
          break;
      }
      dispatch('setSnackRedirect', {text:text, id: data.projectId })
    });

  },

  setSnack({commit}, text){
    commit('setSnackTrigger',true)
    commit('setSnackText', text)
  },
  setSnackFeedback({commit}, value){
    commit('setSnackTrigger',true)
    commit('setSnackText', value.text)
    commit('setSnackTimeout', value.timeout)
  },
  setSnackRedirect({commit}, payload){
    commit('setSnackTrigger',true)
    commit('setSnackText', payload.text)
    commit('setSnackTimeout', -1)
    commit('setSnackRedirect', payload.id)
  },
  clearSnack({commit}){
    commit('setSnackTrigger',false)
    commit('setSnackText', "La operación ha sido exitosa!")
    commit('setSnackTimeout', undefined)
    commit('setSnackRedirect', undefined)
  },

  setInvestmentModal({commit}, value){
    commit('setInvestmentModalTrigger',true)
    commit('setInvestmentData', value)
  },
  clearInvestment({commit}){
    commit('setInvestmentModalTrigger',false)
    commit('setInvestmentData', undefined)
  },

  clearUserRole({commit}){
    commit('setUserRole', undefined)
  }
}